// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"18e8a473","453":"854fe418","736":"86808cc3","753":"1d584a72"}[chunkId] + ".chunk.js";
};